import { LocalizationProvider } from '@mui/x-date-pickers-pro';
import { AdapterLuxon } from '@mui/x-date-pickers-pro/AdapterLuxon';
import React from 'react';
export const MuiLocalizationProvider = LocalizationProvider;
export const LocalizationProviderLuxon = ({ children, }) => (React.createElement(MuiLocalizationProvider, { dateAdapter: AdapterLuxon }, children));
export const wrapPageLocalizationProviderLuxon = (pages) => pages.map(page => ({
    ...page,
    render: (React.createElement(LocalizationProviderLuxon, null, page.render)),
}));
